
// fullClassName ->  column ALIAS in DB TABLE sc_resource.
// resource     ->  column NAME in DB TABLE sc_resource.
// accordions   ->  Number of accordions in edit page.
export const metaData: { fullClassName: string , resource: string , accordions: any } = {
    fullClassName: 'com.tangoe.prime.security.multitenant.User',
    resource: 'USER',
    accordions: [],
  };
